<!-- help帮助中心 -->
<template>
  <div class="help">
    <el-tooltip effect="dark" content="帮助中心" placement="bottom">
      <el-button class="d2-mr btn-text can-hover" type="text">
        <span class="iconfont iconnav_bangzhuzhongxin" style="font-size:16px"  @click="goHelp"></span>
      </el-button>
    </el-tooltip>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  props: {

  },
  data () {
    return {

    }
  },
  methods: {
    goHelp () {
      this.$router.push('/help')
    }
  }
}
</script>

<style scoped lang="scss">
.help {
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/help-center/index.vue"
}
</vue-filename-injector>
